export const PAYMENT_STATUS = { FETCHING: 1, COMPLETED: 2, INITIAL: 0 };
